import { Address } from "./../../services/address";

export const state = {};

export const mutations = {};

export const getters = {};

export const actions = {
  createAddress({ commit }, address) {
    return Address.create(address)
      .then(response => {
        commit(
          "user/ADD_ADDRESS_TO_USER",
          { address: response.data },
          { root: true }
        );
        return response;
      })
      .catch(error => error);
  },
  updateAddress({ commit }, address) {
    return Address.update(address)
      .then(response => {
        commit("user/ADD_ADDRESS_TO_USER", { address }, { root: true });
        return address;
      })
      .catch(error => error);
  }
};
